import { dimText, parseDim, snapToSixteenth } from "../utils/feetInches";

// A dimension field that shows and accepts feet and inches (13'-7 5/8") — or the metric form when the viewer works in metric —
// while the stored value stays decimal feet snapped to 1/16". Uncontrolled like the number fields it replaces: the text is
// seeded from the stored value (re-seeded when that changes), and committed on blur / Enter. Text that is not a dimension is
// put back, never saved.

export default function FeetInchesInput({ valueFt, onCommit, units = "imperial", disabled, style, placeholder = "—", ariaLabel, title }) {
  const stored = valueFt === null || valueFt === undefined || valueFt === "" ? null : snapToSixteenth(valueFt);
  const show = stored === null ? "" : dimText(stored, units);
  const commit = (e) => {
    const raw = e.target.value.trim();
    if (raw === "") { if (stored !== null) onCommit(null); return; }
    const ft = parseDim(raw, units);
    if (ft === null || !(ft >= 0)) { e.target.value = show; return; }       // not a dimension (or negative): put it back
    const next = snapToSixteenth(ft);
    if (next === stored) { e.target.value = show; return; }                  // unchanged (possibly re-typed): tidy the text
    onCommit(next);
  };
  return (
    <input
      key={`${units}-${stored ?? ""}`}
      type="text" inputMode="text" autoComplete="off"
      defaultValue={show} disabled={disabled} placeholder={placeholder} aria-label={ariaLabel} title={title ?? `Feet and inches, e.g. 13'-7 5/8" (a plain number is feet)`}
      style={style}
      onKeyDown={e => { if (e.key === "Enter") e.currentTarget.blur(); }}
      onBlur={commit}
    />
  );
}
